import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { AlertNotificationService } from '../../../services/alert-notification.service';
import { ProposalsService } from '../../../services/api/proposals.service';
import { ProposalsFormComponent } from '../components/proposals-form/proposals-form.component';
import { ProposalsDataComponent } from '../components/proposals-data/proposals-data.component';
import { ProposalsDetailsFormRequestComponent } from '../components/proposals-details-form-request/proposals-details-form-request.component';
import { ProposalsProgressBarComponent } from '../components/proposals-progress-bar/proposals-progress-bar.component';
import { RankingBarComponent } from '../../customers/components/ranking-bar/ranking-bar.component';
import { ProposalsAttachmentsPanelComponent } from '../components/proposals-attachments-panel/proposals-attachments-panel.component';
import { ProposalsOtherComponent } from '../components/proposals-other/proposals-other.component';
import { ProposalsCampaignsComponent } from '../components/proposals-campaigns/proposals-campaigns.component';
import { FormNotesCustomersComponent } from '../../customers/components/notes-customers-form/notes-customers-form.component';
import { FormService } from '../../../services/form.service';
import { MainLayoutService } from '../../../services/main-layout.service';

import { ProposalsItemsComponent } from '../components/proposals-items/proposals-items.component';
import { HttpParams } from '@angular/common/http';
import { NgbAlert, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { SavedDataInfo } from '../../../models/form/saved-data-info';
import { CampaignsService } from 'src/app/services/api/campaigns.service';
import { AlertInfo } from 'src/app/models/alert-info';
import { LoaderComponent } from 'src/app/components/widgets/loader/loader.component';
import { LoaderConfig } from 'src/app/components/widgets/loader/loader.config';
import { LoaderService } from 'src/app/services/loader.service';
import { Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProposalsScopeChangeComponent } from '../components/proposals-scope-change/proposals-scope-change.component';
import { ProposalsReasonChangeOfScopeComponent } from '../components/proposals-reason-change-of-scope/proposals-reason-change-of-scope.component';
import { TextAreaFieldComponent } from '../../../components/form/textarea-field/textarea-field.component';
import { RouteService } from 'src/app/services/route.service';
import { AccessControlService } from '../../../services/access-control.service';
import { FeatureActionKey } from '../../../layouts/main-layout/components/sidebar/config/access-control.config';

@Component({
  selector: 'app-proposals-edit-page',
  imports: [ProposalsProgressBarComponent, RankingBarComponent, ProposalsDetailsFormRequestComponent, ProposalsFormComponent, ProposalsDataComponent, FormNotesCustomersComponent, ProposalsItemsComponent, ProposalsAttachmentsPanelComponent, ProposalsOtherComponent, ProposalsCampaignsComponent, NgbAlert, LoaderComponent, ProposalsScopeChangeComponent, ProposalsReasonChangeOfScopeComponent, TextAreaFieldComponent, ReactiveFormsModule],
  templateUrl: './proposals-edit-page.component.html',
  styleUrl: './proposals-edit-page.component.scss'
})
export class ProposalsEditPageComponent implements OnInit, OnDestroy, AfterViewInit {
  proposal: any;
  proposalItems: any[] = [];
  proposalNotes: any;
  readonly: boolean;
  proposalId!: number;
  allItemsVerificed?: boolean;
  campaigns: any;
  isChangeOfScopePage: boolean = false;
  isScopeChangePage: boolean = false;

  form!: FormGroup;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  hasItemsWithWarning: boolean = false;
  allJustificationsProvided: boolean = false;
  nextStateButtonType: 'tech' | 'overdiscount' = 'tech';

  hasUnsavedChanges: boolean = false;
  initialLoadComplete: boolean = false;
  isItemsLocked: boolean = false;
  targetExchangeRate: number | null = null;
  targetCurrencyLabel: string | null = null;

  @ViewChild('proposalsForm') proposalsForm!: ProposalsFormComponent;
  @ViewChild('proposalsData') proposalsData!: ProposalsDataComponent;
  @ViewChild('proposalsDetailsForm') proposalsDetailsForm!: ProposalsDetailsFormRequestComponent;
  @ViewChild('proposalsReasonChangeOfScope') proposalsReasonChangeOfScope!: ProposalsReasonChangeOfScopeComponent;
  @ViewChild('proposalsOther') proposalsOther!: ProposalsOtherComponent;
  @ViewChild('rankingBar') rankingBar!: RankingBarComponent;
  @ViewChild('proposalsItems') proposalsItems!: ProposalsItemsComponent;

  private statusMap: string[] = [
    'Sales',
    'Overdiscount Approval',
    'Tech Approval',
    'Sales Overall Check',
    'Pending Client',
    'Accepted / Not Accepted'
  ];

  buttonState: 'success' | 'danger' = 'danger';

  isLoading: boolean = false;
  loaderConfig: LoaderConfig = {
    type: 'spinner',
    text: 'Saving in progress...',
    overlay: true
  };

  private allTechApprovalVerified: boolean = false;

  private loaderSubscription: Subscription | null = null;
  private readonly LOADER_CONTEXT = 'proposals-edit-page';
  private destroy$ = new Subject<void>();
  private isReloadingProposalData: boolean = false;

  canActOnCurrentStatus: boolean = false;
  private currentProfileCode: string | null = null;

  rejectCommentControl = new FormControl('');

  constructor(
    protected proposalsService: ProposalsService,
    private route: ActivatedRoute,
    private alertNotificationService: AlertNotificationService,
    private formService: FormService,
    private mainLayoutService: MainLayoutService,
    private router: Router,
    private modalService: NgbModal,
    private campaignsService: CampaignsService,
    private loaderService: LoaderService,
    private viewportScroller: ViewportScroller,
    private routeService: RouteService,
    private accessControlService: AccessControlService
  ) {
    this.readonly = false;
  }

  ngOnInit(): void {
    this.viewportScroller.scrollToPosition([0, 0]);

    this.initialLoadComplete = false;
    this.hasUnsavedChanges = false;

    const urlWithoutQuery = this.router.url.split('?')[0];
    this.isChangeOfScopePage = urlWithoutQuery.includes('/proposals/change-of-scope');

    this.mainLayoutService.isScopeChangePage$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.isScopeChangePage = value;
      });

    this.mainLayoutService.activeProfile$
      .pipe(takeUntil(this.destroy$))
      .subscribe(profileCode => {
        this.currentProfileCode = profileCode;
        this.computeCanActOnCurrentStatus();
      });

    if (this.isChangeOfScopePage) {
      setTimeout(() => {
        this.router.navigateByUrl(this.router.url, { skipLocationChange: true }).then(() => {
          console.log('Navigation complete, scope change flag should be updated');
        });
      }, 100);
    }


    this.loaderSubscription = this.loaderService
      .getLoadingAsObservable(this.LOADER_CONTEXT)
      .subscribe(isLoading => this.isLoading = isLoading);

    const params = new HttpParams().set('size', '9999');
    const proposalId = this.route.snapshot.paramMap.get('proposalId');
    this.proposalId = Number(proposalId);

    const requestIdParam = this.route.snapshot.queryParamMap.get('requestId');
    const requestId = requestIdParam ? Number(requestIdParam) : null;

    const initProposalIdParam = this.route.snapshot.queryParamMap.get('proposalId');
    const initProposalId = initProposalIdParam ? Number(initProposalIdParam) : null;

    this.isItemsLocked = !proposalId;

    if (proposalId) {
      this.proposalsService?.detail(this.proposalId)?.subscribe((response: any) => {
        if (response?.status?.code === 200) {
          this.proposal = response?.data?.proposal;
          this.proposal.isShowButton = ['SALES', 'TECH_APPROVAL', 'OVERDISCOUNT_APPROVAL'].includes(this.proposal.status);

          if (this.proposal?.status === 'Accepted / Not Accepteds' || this.proposal?.status === 'Pending Client') {
            this.readonly = true;
          }
          this.mainLayoutService.setRelatedCodeItem(this.proposal.code || null);

          if (this.proposal && this.proposal.isChangeOfScope === true) {
            this.mainLayoutService.setIsScopeChangePage(true);
          } else {
            this.mainLayoutService.setIsScopeChangePage(false);
          }

          if (this.proposal?.status === 'SALES') {
            this.allTechApprovalVerified = true;
          }

          this.checkProposalState();
          this.computeCanActOnCurrentStatus();
        }
      });

      this.proposalsService.listItems(this.proposalId, { params }).subscribe((response: any) => {
        if (response?.status?.code === 200) {
          this.proposalItems = response?.data?.proposalItems;
          setTimeout(() => {
            this.checkProposalState();
          }, 500);
        }
      });

      this.proposalsService.listNotes(this.proposalId, { params }).subscribe(response => {
        if (response.status.code === 200) {
          this.proposalNotes = response?.data?.sectionNotes;
        }
      });
    } else if (requestId) {
      this.proposalsService.initFromRequest(requestId).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.proposal = response.data.proposal;
          this.proposal.request.requestId = requestId;
          this.proposal.isShowButton = false;
          
          if (this.proposal.proposalId) {
            this.proposalId = this.proposal.proposalId;
          }
          
          this.mainLayoutService.setRelatedCodeItem(this.proposal.code || null);

          if (this.proposal && this.proposal.isChangeOfScope === true) {
            this.mainLayoutService.setIsScopeChangePage(true);
          } else {
            this.mainLayoutService.setIsScopeChangePage(false);
          }

          if (response.data.items && response.data.items.length > 0) {
            this.proposalItems = response.data.items;
          } else if (this.proposal.items && this.proposal.items.length > 0) {
            this.proposalItems = this.proposal.items;
          }

          this.checkProposalState();
        }
      });
    } else if (initProposalId) {
      this.proposalsService.setIsFromProposalInit(true);

      this.proposalsService.initFromProposal(initProposalId).subscribe((response: any) => {
        if (response.status.code === 200) {
          this.proposal = response.data.proposal;

          if (!this.proposal.parentProposal && !this.proposal.parentProposal.parentProposalId) {
            this.proposal.parentProposal.parentProposalId = Number(initProposalId);
          }
          
          this.proposal.status = 'SALES';

          if (this.proposal && this.proposal.isChangeOfScope === true) {
            this.mainLayoutService.setIsScopeChangePage(true);
          } else {
            this.mainLayoutService.setIsScopeChangePage(false);
          }

          this.proposal.isShowButton = false;
          this.mainLayoutService.setRelatedCodeItem(this.proposal.code || null);
          this.checkProposalState();
        }
      });

      this.proposalsService.listItems(initProposalId, { params }).subscribe((response: any) => {
        if (response?.status?.code === 200) {
          this.proposalItems = response?.data?.proposalItems;

          setTimeout(() => {
            
            if (this.proposalItems && Array.isArray(this.proposalItems)) {
              this.proposalItems = this.proposalItems.map(item => {
                return {
                  ...item,
                  proposalItemId: null 
                };
              });
            }
            this.checkProposalState();
          }, 500);
        }
      });
    }

    this.campaignsService.list({ params }).subscribe({
      next: (response: any) => {
        this.campaigns = response.data.campaigns;


        setTimeout(() => {
          this.updateButtonState();
        }, 1000);
        setTimeout(() => {
          this.checkProposalState();
        }, 500);
      },
      error: (error: any) => {
        console.error('Error loading platforms:', error);
        this.alertNotificationService.error('Error loading platforms');
      }
    });
  }

  updateProposalId(newProposalId: number): void {
    if (newProposalId) {
      this.proposalId = newProposalId;

      if (!this.proposal) {
        this.proposal = { proposalId: newProposalId };
      } else {
        this.proposal.proposalId = newProposalId;
      }

      if (this.proposalsItems) {
        this.proposalsItems.proposalId = newProposalId;
        console.log('ProposalId updated in child components:', newProposalId);
      }
    }
  }

  async submitAllForms(): Promise<void> {
    try {
      this.alertInfo = { show: false, type: '', message: '' };
      this.loaderService.startLoading(this.LOADER_CONTEXT);

      const formPromises = [
        this.validateAndSaveForm(this.proposalsForm),
        this.validateAndSaveForm(this.proposalsData),
        this.validateAndSaveForm(this.proposalsOther),
        this.validateAndSaveForm(this.rankingBar),
        this.validateAndSaveForm(this.proposalsDetailsForm),
        this.validateAndSaveForm(this.proposalsReasonChangeOfScope)
      ];

      const results = await Promise.all(formPromises);

      const reasonChangeOfScopeResult = results[5];
      if ((this.isChangeOfScopePage || this.isScopeChangePage) && reasonChangeOfScopeResult?.success === false) {
        this.showAlertInfo('danger', 'Please provide the reason of change of scope');
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
        return;
      }

      const combinedData = results.reduce((acc, result) => {
        if (result && result.response && typeof result.response === 'object') {
          return { ...acc, ...result.response };
        }
        return acc;
      }, {});

      const initProposalIdParam = this.route.snapshot.queryParamMap.get('proposalId');

      if (initProposalIdParam) {
        if (this.proposal?.parentProposal?.proposalId) {
          combinedData.parentProposalId = this.proposal.parentProposal.proposalId;
          combinedData.code = this.proposal.code;
        } else if (this.proposal?.parentProposalId) {
          combinedData.parentProposalId = this.proposal.parentProposalId;
          combinedData.code = this.proposal.code;
        } else {
          combinedData.parentProposalId = Number(initProposalIdParam);
          combinedData.code = this.proposal.code;
        }

        console.log('Added parentProposalId to form data:', combinedData.parentProposalId);
      }

      if (this.proposal?.proposalId && Object.keys(combinedData).length > 0) {
        this.proposalsService.update(this.proposal.proposalId, combinedData).subscribe({
          next: (response) => {
            this.proposalsService.resetAfterSuccessfulSave();

            if (response && response.data && response.data.proposal && response.data.proposal.proposalId) {
              this.updateProposalId(response.data.proposal.proposalId);
            }

            this.showAlertInfo('success', 'Proposal saved successfully');
            this.loaderService.stopLoading(this.LOADER_CONTEXT);
          },
          error: (error) => {
            this.submitFormError(error);
            this.showAlertInfo('danger', error.error?.error?.message || 'Error while saving the proposal');
            this.loaderService.stopLoading(this.LOADER_CONTEXT);
          }
        });
      } else if (Object.keys(combinedData).length > 0 && !this.proposal?.proposalId) {
        this.proposalsService.create(combinedData).subscribe({
          next: (response) => {
            this.proposalsService.resetAfterSuccessfulSave();

            if (response && response.data && response.data.proposal && response.data.proposal.proposalId) {
              this.updateProposalId(response.data.proposal.proposalId);
            }

            this.isItemsLocked = false;

            this.showAlertInfo('success', 'Proposal saved successfully');
            this.loaderService.stopLoading(this.LOADER_CONTEXT);
          },
          error: (error) => {
            this.submitFormError(error);
            this.showAlertInfo('danger', error.error?.error?.message || 'Error while saving the proposal');
            this.loaderService.stopLoading(this.LOADER_CONTEXT);
          }
        });
      } else {
        console.warn('Missing proposal ID or no data to save');
        this.showAlertInfo('danger', 'No changes to save or missing proposal information');
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
      }
    } catch (error) {
      console.error('Error during form submission process:', error);
      this.showAlertInfo('danger', 'An error occurred while processing your request');
      this.loaderService.stopLoading(this.LOADER_CONTEXT);
    }
  }

  private validateAndSaveForm(component: any): Promise<any> {
    if (!component) {
      return Promise.resolve({ success: true, response: {} });
    }
    const createTimeoutPromise = (timeMs: number = 2000) => {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve({ success: true, response: {}, timedOut: true });
        }, timeMs);
      });
    };

    if (component === this.rankingBar) {
      return Promise.race([
        new Promise((resolve) => {
          try {
            if (component.rankingChange) {
              const subscription = component.rankingChange.subscribe((newRanking: any) => {
                resolve({ success: true, response: { ranking: newRanking } });
                subscription.unsubscribe();
              });
            }

            if (component.saveRanking && typeof component.saveRanking === 'function') {
              component.saveRanking();
            } else if (component.saveRanking$) {
              component.saveRanking$.next();
            } else {
              resolve({ success: true, response: { ranking: component.ranking } });
            }
          } catch (err) {
            console.error('Error in rankingBar processing:', err);
            resolve({ success: true, response: {} });
          }
        }),
        createTimeoutPromise()
      ]);
    }
    else if (component?.onSavedData) {
      return Promise.race([
        new Promise((resolve) => {
          try {
            const subscription = component.onSavedData.subscribe({
              next: (result: any) => {
                resolve(result || { success: true, response: {} });
                subscription.unsubscribe();
              },
              error: (err: any) => {
                console.error('Error in component.onSavedData:', err);
                resolve({ success: true, response: {} });
                subscription.unsubscribe();
              }
            });

            if (component.submitForm && typeof component.submitForm === 'function') {
              component.submitForm();
            } else {
              resolve({ success: true, response: {} });
            }
          } catch (err) {
            console.error('Error in component processing:', err);
            resolve({ success: true, response: {} });
          }
        }),
        createTimeoutPromise()
      ]);
    }
    else {
      const formValue = component.form?.value || {};
      return Promise.resolve({ success: true, response: formValue });
    }
  }

  submitFormError(error: any) {
    if (error.error?.error?.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
      this.showAlertInfo('danger', 'Please correct the validation errors');
    } else if (error.error?.error?.message) {
      this.showAlertInfo('danger', error.error.error.message);
    }
  }

  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.proposalsForm?.form);
    this.formService.setValidationErrors(this.proposalsForm?.form, validationErrors);
  }

  showAlertInfo(type: string, message: string): void {
    this.alertInfo = { show: true, type, message };
    if (type === 'success') {
      this.alertNotificationService.success(message);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }

  getNextStatus(): string | null {
    const currentIndex = this.statusMap.indexOf(this.proposal?.status);
    return currentIndex >= 0 && currentIndex < this.statusMap.length - 1
      ? this.statusMap[currentIndex + 1]
      : null;
  }


  hasDiscountOverLimit(): boolean {
    if (!this.proposalItems || this.proposalItems.length === 0) {
      return false;
    }


    const itemsWithWarning = this.proposalItems.filter((item: any) => this.isItemOverDiscount(item));

    return itemsWithWarning.length > 0;
  }

  private isItemOverDiscount(item: any): boolean {
    return this.proposalsService.isOverDiscount({
      discount: item?.discountPercent,
      maxDiscount: item?.maxDiscount
    });
  }

  allDiscountsAccepted(): boolean {
    if (!this.proposalItems || this.proposalItems.length === 0) {
      return true;
    }

    const itemsOverLimit = this.proposalItems.filter(item => this.isItemOverDiscount(item));


    if (itemsOverLimit.length > 0) {
      itemsOverLimit.forEach((item, index) => {
      });
    }

    const allHaveJustification = itemsOverLimit.length === 0 ||
      itemsOverLimit.every(item =>
        (item.overdiscountReason && item.overdiscountReason.trim() !== '') ||
        (item.discountJustification && item.discountJustification.trim() !== '')
      );

    const allAreVerified = itemsOverLimit.length === 0 ||
      itemsOverLimit.every(item => item.isVerifiedOverdiscount === true);


    const result = allHaveJustification && allAreVerified;
    return result;
  }


  goToState(newStatus: string, additionalData?: any, navigateToDetailOnSuccess: boolean = false): void {
    const hasPendingItemChanges = this.proposalsItems
      ? this.proposalsItems.hasChanges
      : this.hasUnsavedChanges;

    this.hasUnsavedChanges = hasPendingItemChanges;

    if (this.proposal?.status === 'SALES' && newStatus === 'TECH_APPROVAL') {
      if (hasPendingItemChanges && this.initialLoadComplete) {
        this.alertNotificationService.error('Save modified items first');
        return;
      }
    }
    else if (hasPendingItemChanges && this.initialLoadComplete &&
      !(this.proposal?.status === 'TECH_APPROVAL' && this.allTechApprovalVerified) &&
      !(this.proposal?.status === 'OVERDISCOUNT_APPROVAL' && this.allItemsVerificed)) {
      this.alertNotificationService.error('Save modified items first');
      return;
    }

    if ((newStatus === 'SALES_OVERALL_CHECK' ||
      (newStatus === 'TECH_APPROVAL' && this.proposal?.status !== 'SALES')) &&
      this.buttonState !== 'success') {
      this.alertNotificationService.error('You need to verify all items before proceeding');
      return;
    }

    if (this.proposal) {
      const scrollPosition = this.viewportScroller.getScrollPosition();
      
      this.loaderService.startLoading(this.LOADER_CONTEXT);

      const updateData: any = {};
      updateData.status = newStatus;
      
      const requestData = additionalData ? { ...additionalData } : {};

      this.proposalsService.changeStatus(this.proposal.proposalId, updateData.status, requestData).subscribe({
        next: (response: any) => {
          this.alertNotificationService.success(`Proposal moved to state: ${newStatus}`);
          this.loaderService.stopLoading(this.LOADER_CONTEXT);

          if (navigateToDetailOnSuccess) {
            this.hasUnsavedChanges = false;
            this.router.navigate([`/app/proposals/${this.proposal.proposalId}`]).then(() => {
              this.viewportScroller.scrollToPosition([0, 0]);
            });
            return;
          }

          this.updateButtonState();

          if (newStatus === 'Overdiscount Approval' || newStatus === 'Sales' || newStatus === 'Tech Approval') {

            this.reloadProposalData(scrollPosition);
          } else {
            this.reloadProposalData(scrollPosition);
          }
        },
        error: (error: any) => {
          this.alertNotificationService.error('Error updating status');
          console.error('Error updating status:', error);
          this.loaderService.stopLoading(this.LOADER_CONTEXT);
        }
      });
    }
  }

  sendToClient(): void {
    this.goToState('PENDING_CLIENT', undefined, true);
  }

  acceptProposal(content: any): void {
    if (this.proposal) {
      this.modalService.open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true
      }).result.then(
        (result) => {
          if (result === 'confirm') {
            const scrollPosition = this.viewportScroller.getScrollPosition();
            
            this.loaderService.startLoading(this.LOADER_CONTEXT);

            this.proposalsService.changeStatus(this.proposal.proposalId, 'ACCEPTED').subscribe({
              next: (response) => {
                this.proposal.status = 'ACCEPTED';
                this.proposal.accepted = true;
                this.alertNotificationService.success('Proposal accepted');
                this.loaderService.stopLoading(this.LOADER_CONTEXT);
                this.reloadProposalData(scrollPosition);
              },
              error: (error) => {
                this.alertNotificationService.error('Error accepting proposal');
                console.error('Error accepting proposal:', error);
                this.loaderService.stopLoading(this.LOADER_CONTEXT);
              }
            });
          }
        },
        () => { }
      );
    }
  }

  rejectProposal(): void {
    if (this.proposal) {
      const scrollPosition = this.viewportScroller.getScrollPosition();
      
      this.loaderService.startLoading(this.LOADER_CONTEXT);

      this.proposalsService.changeStatus(this.proposal.proposalId, 'NOT_ACCEPTED').subscribe({
        next: (response) => {
          this.proposal.status = 'NOT_ACCEPTED';
          this.proposal.accepted = false;
          this.alertNotificationService.success('Proposal rejected');
          this.loaderService.stopLoading(this.LOADER_CONTEXT);
          this.reloadProposalData(scrollPosition);
        },
        error: (error) => {
          this.alertNotificationService.error('Error rejecting proposal');
          console.error('Error rejecting proposal:', error);
          this.loaderService.stopLoading(this.LOADER_CONTEXT);
        }
      });
    }
  }

  rejectTechnicalApproval(content: any): void {
    this.rejectCommentControl.setValue('');
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-reject-tech-approval',
      centered: true,
      size: 'lg'
    }).result.then(
      (result) => {
        if (result === 'confirm') {
          const comment = this.rejectCommentControl.value;
          this.goToState('SALES', { message: comment });
        }
      },
      () => {
        this.rejectCommentControl.setValue('');
      }
    );
  }


  goToProject(): void {
    this.loaderService.startLoading(this.LOADER_CONTEXT);
    this.proposalsService.createProjectFromProposal(this.proposalId, {}).subscribe({
      next: (response: any) => {
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
        if (response?.status?.code === 200 || response?.status?.code === 201) {
          const projectId = response?.data?.project?.projectId;
          if (projectId) {
            this.alertNotificationService.success('Project successfully created');
            this.router.navigate([`/app/projects/update/${projectId}`]).then(() => {
              this.viewportScroller.scrollToPosition([0, 0]);
            });
          } else {
            this.alertNotificationService.error('Project created but ID not found');
            this.router.navigate(['/app/projects']);
          }
        } else {
          this.alertNotificationService.error('Error creating project');
        }
      },
      error: (error: any) => {
        this.loaderService.stopLoading(this.LOADER_CONTEXT);
        console.error('Error creating project from proposal:', error);
        this.alertNotificationService.error('Error creating project: ' + (error?.error?.message || error?.message || 'Unknown error'));
      }
    });
  }

  openConfirmationDialog(content: any): void {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      centered: true
    }).result.then(
      (result) => { },
      () => { }
    );
  }

  ngOnDestroy(): void {
    this.mainLayoutService.setRelatedCodeItem(null);
    this.mainLayoutService.setIsScopeChangePage(false);
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    this.loaderService.stopLoading(this.LOADER_CONTEXT);

    this.proposalsService.setSaveButtonDisabled(false);
    this.proposalsService.setIsFromProposalInit(false);

    this.destroy$.next();
    this.destroy$.complete();
  }

  handleTargetConversionChange(event: { rate: number | null; currencyLabel: string | null }): void {
    this.targetExchangeRate = event.rate;
    this.targetCurrencyLabel = event.currencyLabel;
  }

  handleVerificationChange(allItemsVerificed: any): void {
    this.buttonState = allItemsVerificed ? 'success' : 'danger';
  }

  handleOverdiscountVerificationChange(allItemsVerificed: boolean): void {
    this.allItemsVerificed = allItemsVerificed;

    if (allItemsVerificed && this.proposal?.status === 'OVERDISCOUNT_APPROVAL') {
      this.hasUnsavedChanges = false;
    }

    this.updateButtonState();
  }


  updateButtonState(): void {
    if (!this.proposal || !this.proposalItems || this.proposalItems.length === 0) {
      this.buttonState = 'danger';
      return;
    }

    if (this.proposal.status === 'SALES') {
      this.buttonState = 'success';
      return;
    }

    if (this.proposal.status === 'OVERDISCOUNT_APPROVAL') {
      if (this.hasUnsavedChanges && this.initialLoadComplete) {
        this.buttonState = 'danger';
        return;
      }

      if (this.allItemsVerificed !== undefined) {
        this.buttonState = this.allItemsVerificed ? 'success' : 'danger';
        return;
      }

      const itemsWithWarning = this.proposalItems.filter(item => this.isItemOverDiscount(item));


      if (itemsWithWarning.length === 0) {
        this.buttonState = 'success';
        return;
      }

      const allVerified = itemsWithWarning.every(item => item.isVerifiedOverdiscount === true);
      this.buttonState = allVerified ? 'success' : 'danger';

      this.allItemsVerificed = allVerified;

      return;
    }

    if (this.proposal.status === 'TECH_APPROVAL') {

      this.buttonState = this.allTechApprovalVerified ? 'success' : 'danger';
      return;
    }

    if (this.allItemsVerificed !== undefined) {
      this.buttonState = this.allItemsVerificed ? 'success' : 'danger';
    }
  }


  handleTechApprovalVerificationChanged(allVerified: boolean): void {
    if (this.proposal?.status === 'SALES') {
      this.allTechApprovalVerified = true;
    } else {
      this.allTechApprovalVerified = allVerified;
    }

    if (allVerified && this.proposal?.status === 'TECH_APPROVAL') {
      this.hasUnsavedChanges = false;
    }

    this.updateButtonState();
  }

  checkProposalState(): void {
    if (!this.proposal || !this.proposalItems || !this.campaigns) {
      return;
    }


    this.hasItemsWithWarning = this.hasDiscountOverLimit();

    if (this.hasItemsWithWarning) {
      this.nextStateButtonType = 'overdiscount';
      this.allJustificationsProvided = this.allDiscountsJustified();
    } else {
      this.nextStateButtonType = 'tech';
    }

    if (this.proposal.status !== 'OVERDISCOUNT_APPROVAL') {
      this.updateButtonState();
    } else {
    }
  }

  private computeCanActOnCurrentStatus(): void {
    const STATUS_TO_KEY: Partial<Record<string, FeatureActionKey>> = {
      SALES: 'PROPOSALS_STATUS_SALES',
      OVERDISCOUNT_APPROVAL: 'PROPOSALS_STATUS_OVERDISCOUNT_APPROVAL',
      TECH_APPROVAL: 'PROPOSALS_STATUS_TECH_APPROVAL',
      SALES_OVERALL_CHECK: 'PROPOSALS_STATUS_SALES_OVERALL_CHECK',
      PENDING_CLIENT: 'PROPOSALS_STATUS_PENDING_CLIENT',
    };
    const key = STATUS_TO_KEY[this.proposal?.status];
    this.canActOnCurrentStatus = key
      ? this.accessControlService.hasFeatureActionAccess(this.currentProfileCode, key, 'modify')
      : false;
  }

  allDiscountsJustified(): boolean {
    if (!this.proposalItems || this.proposalItems.length === 0) {
      return true;
    }

    const itemsOverLimit = this.proposalItems.filter(item => this.isItemOverDiscount(item));


    const allJustified = itemsOverLimit.length === 0 || itemsOverLimit.every(item =>
      (item.overdiscountReason && item.overdiscountReason.trim() !== '') ||
      (item.discountJustification && item.discountJustification.trim() !== '')
    );

    return allJustified;
  }

  handleItemChange(savedDataInfo?: SavedDataInfo): void {
    this.hasUnsavedChanges = false;
    if (savedDataInfo?.success && this.proposalId) {

      if (savedDataInfo.response) {
        if (typeof savedDataInfo.response.allOverdiscountVerified === 'boolean') {
          this.allItemsVerificed = savedDataInfo.response.allOverdiscountVerified;
        }

        if (typeof savedDataInfo.response.allTechApprovalVerified === 'boolean') {
          if (this.proposal?.status === 'SALES') {
            this.allTechApprovalVerified = true;
          } else {
            this.allTechApprovalVerified = savedDataInfo.response.allTechApprovalVerified;
          }
        }
      }

      const currentUrl = this.router.url;
      const isCreateMode = currentUrl.includes('/proposals/create');
      const requestIdParam = this.route.snapshot.queryParamMap.get('requestId');
      
      if (isCreateMode && requestIdParam && this.proposalId) {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        setTimeout(() => {
          this.router.navigate([`/app/proposals/update/${this.proposalId}`], { state: { restoreScrollY: scrollY } });
          return;
        }, 1000);
      }

      if (this.isChangeOfScopePage && this.proposalId) {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        setTimeout(() => {
          this.router.navigate([`/app/proposals/update/${this.proposalId}`], { state: { restoreScrollY: scrollY } });
        }, 1000);
        return;
      }

      this.proposalsService.listItems(this.proposalId).subscribe({
        next: (response: any) => {
          if (response && response.data && response.data.proposalItems) {
            this.proposalItems = response.data.proposalItems;

            this.checkProposalState();

            if (this.proposal?.status === 'OVERDISCOUNT_APPROVAL') {
              const itemsOverLimit = this.proposalItems.filter(item => this.isItemOverDiscount(item));



              const allVerified = itemsOverLimit.length === 0 ||
                itemsOverLimit.every(item => item.isVerifiedOverdiscount === true);

              this.allItemsVerificed = allVerified;
              this.buttonState = allVerified ? 'success' : 'danger';
            } else if (this.proposal?.status === 'TECH_APPROVAL' && this.proposalsItems) {
              setTimeout(() => {
                const allVerified = this.proposalsItems.verifyTechApprovalItems();
                this.allTechApprovalVerified = allVerified;
                this.updateButtonState();
              }, 100);
            } else {
              this.updateButtonState();
            }
          }
        },
        error: (error: unknown) => {
          console.error('Errore nel caricare gli items dopo il salvataggio:', error);
        }
      });
    } else {
      this.checkProposalState();

      if (this.proposal?.status === 'TECH_APPROVAL' && this.proposalsItems) {
        setTimeout(() => {
          const allVerified = this.proposalsItems.verifyTechApprovalItems();
          this.allTechApprovalVerified = allVerified;
          this.updateButtonState();
        }, 100);
      } else if (this.proposal?.status === 'OVERDISCOUNT_APPROVAL' && this.proposalsItems) {
        setTimeout(() => {
          const allVerified = this.proposalsItems.verifyOverdiscountItems();
          this.allItemsVerificed = allVerified;
          this.updateButtonState();
        }, 100);
      } else {
        this.updateButtonState();
      }
    }
  }

  handleDiscountWarningChange(event: { hasWarning: boolean, allJustified: boolean }): void {
    this.hasItemsWithWarning = event.hasWarning;
    this.allJustificationsProvided = event.hasWarning ? event.allJustified : true;

    if (event.hasWarning) {
      this.nextStateButtonType = 'overdiscount';

    } else {
      this.nextStateButtonType = 'tech';
    }
  }

  handleItemsChangedState(hasChanges: boolean): void {

    if (!this.initialLoadComplete || this.isReloadingProposalData) {
      return;
    }

    this.hasUnsavedChanges = hasChanges;

    this.updateButtonState();
  }

  requestOverdiscountApproval(): void {
    if (!this.allDiscountsJustified()) {
      this.showAlertInfo('danger', 'You must provide a justification for all discounts that exceed the limit');
      return;
    }

    this.goToState('OVERDISCOUNT_APPROVAL');
  }

  ngAfterViewInit(): void {
    const restoreScrollY: number | undefined = history.state?.restoreScrollY;
    if (!restoreScrollY) {
      this.viewportScroller.scrollToPosition([0, 0]);
    } else {
      setTimeout(() => {
        window.scrollTo({ top: restoreScrollY, behavior: 'smooth' });
      }, 100);
    }

    setTimeout(() => {
      if (this.proposal && this.proposal.status === 'OVERDISCOUNT_APPROVAL') {
        if (this.proposalsItems) {

          this.proposalsItems.checkDiscountWarnings();

          const allVerified = this.proposalsItems.verifyOverdiscountItems();

          setTimeout(() => {

            this.updateButtonState();

            this.initialLoadComplete = true;

            this.hasUnsavedChanges = false;

            this.updateButtonState();

          }, 500);
        }
      } else if (this.proposal && this.proposal.status === 'TECH_APPROVAL') {
        if (this.proposalsItems) {
          const allTechVerified = this.proposalsItems.verifyTechApprovalItems();
          this.allTechApprovalVerified = allTechVerified;
        }

        setTimeout(() => {
          this.updateButtonState();
          this.initialLoadComplete = true;
          this.hasUnsavedChanges = false;
        }, 500);
      } else {
        this.checkProposalState();

        setTimeout(() => {
          this.initialLoadComplete = true;
          this.hasUnsavedChanges = false;
          this.checkProposalState();
        }, 500);
      }
    }, 1500);
  }

  private reloadProposalData(scrollPosition: [number, number]): void {
    if (!this.proposalId) return;

    this.isReloadingProposalData = true;
    this.initialLoadComplete = false;
    this.hasUnsavedChanges = false;

    const params = new HttpParams().set('size', '9999');
    this.proposalsService?.detail(this.proposalId)?.subscribe((response: any) => {
      if (response?.status?.code === 200) {
        this.proposal = response?.data?.proposal;
        this.proposal.isShowButton = ['SALES', 'TECH_APPROVAL', 'OVERDISCOUNT_APPROVAL'].includes(this.proposal.status);

        if (this.proposal?.status === 'Accepted / Not Accepteds' || this.proposal?.status === 'Pending Client') {
          this.readonly = true;
        }
        this.mainLayoutService.setRelatedCodeItem(this.proposal.code || null);

        if (this.proposal && this.proposal.isChangeOfScope === true) {
          this.mainLayoutService.setIsScopeChangePage(true);
        } else {
          this.mainLayoutService.setIsScopeChangePage(false);
        }

        if (this.proposal?.status === 'SALES') {
          this.allTechApprovalVerified = true;
        }

        this.checkProposalState();
        this.computeCanActOnCurrentStatus();

        setTimeout(() => {
          this.viewportScroller.scrollToPosition(scrollPosition);
        }, 100);
      }
    });
    this.proposalsService.listItems(this.proposalId, { params }).subscribe((response: any) => {
      if (response?.status?.code === 200) {
        this.proposalItems = response?.data?.proposalItems;
        setTimeout(() => {
          this.checkProposalState();
          this.hasUnsavedChanges = false;
          this.initialLoadComplete = true;
          this.isReloadingProposalData = false;
        }, 500);
      }
    });
    this.proposalsService.listNotes(this.proposalId, { params }).subscribe(response => {
      if (response.status.code === 200) {
        this.proposalNotes = response?.data?.sectionNotes;
      }
    });
  }

  goToViewProposal(): void {
    if (!this.proposalId) {
      return;
    }
    this.routeService.proposalsDetail(this.proposalId);
  }
}
